export default "__VITE_ASSET__e0a7eac8__"